import React from 'react';
import { Button, Col, Dropdown, Form, Input, Row, Select, Space } from 'antd';
import type { FormInstance } from 'antd';
import {
  MoreOutlined,
  PlusOutlined,
  PushpinFilled,
  PushpinOutlined,
  ReloadOutlined,
  SearchOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import type { ProductQueryParams } from '../../../types/product';

const { Option } = Select;

interface ProductFiltersProps {
  searchForm: FormInstance;
  queryParams: ProductQueryParams;
  selectedCount: number;
  pinLoading: boolean;
  syncLoading: boolean;
  proxySyncLoading: boolean;
  onSearch: (values: ProductQueryParams) => void;
  onReset: () => void;
  onCreate: () => void;
  onSyncExternal: () => void;
  onSyncExternalProxy: () => void;
  onBatchPin: (isPinned: boolean) => void;
}

const ProductFilters: React.FC<ProductFiltersProps> = ({
  searchForm,
  queryParams,
  selectedCount,
  pinLoading,
  syncLoading,
  proxySyncLoading,
  onSearch,
  onReset,
  onCreate,
  onSyncExternal,
  onSyncExternalProxy,
  onBatchPin,
}) => {
  return (
    <div className="page-header" style={{ marginBottom: 12, padding: '0 8px' }}>
      <Row gutter={8} align="middle">
        <Col flex="auto">
          <Form
            form={searchForm}
            layout="inline"
            onFinish={onSearch}
            initialValues={queryParams}
            style={{ padding: '8px 0' }}
          >
            <Form.Item name="keyword" style={{ marginBottom: 0 }}>
              <Input placeholder="搜索商品名称" prefix={<SearchOutlined />} style={{ width: 200 }} />
            </Form.Item>
            <Form.Item name="status" style={{ marginBottom: 0 }}>
              <Select placeholder="选择状态" style={{ width: 120 }}>
                <Option value="">全部</Option>
                <Option value="在售">在售</Option>
                <Option value="已下架">已下架</Option>
              </Select>
            </Form.Item>
            <Form.Item name="external_status" style={{ marginBottom: 0 }}>
              <Select placeholder="外部产品状态" style={{ width: 120 }}>
                <Option value="">全部</Option>
                <Option value="在售">外部在售</Option>
                <Option value="已下架">外部下架</Option>
              </Select>
            </Form.Item>
            <Form.Item name="source_platform" style={{ marginBottom: 0 }}>
              <Select placeholder="来源平台" style={{ width: 110 }}>
                <Option value="">全部</Option>
                <Option value="haoyi">号易</Option>
                <Option value="172">172平台</Option>
                <Option value="manual">手动</Option>
              </Select>
            </Form.Item>
            <Form.Item name="operator" style={{ marginBottom: 0 }}>
              <Select placeholder="选择运营商" style={{ width: 120 }}>
                <Option value="">全部</Option>
                <Option value="移动">移动</Option>
                <Option value="电信">电信</Option>
                <Option value="联通">联通</Option>
                <Option value="广电">广电</Option>
              </Select>
            </Form.Item>
            <Form.Item name="is_hidden_from_client" style={{ marginBottom: 0 }}>
              <Select placeholder="客户端展示" style={{ width: 130 }}>
                <Option value="">全部</Option>
                <Option value={false}>客户端可见</Option>
                <Option value={true}>客户端隐藏</Option>
              </Select>
            </Form.Item>
            <Form.Item name="duplicate_status" style={{ marginBottom: 0 }}>
              <Select placeholder="重复状态" style={{ width: 130 }}>
                <Option value="">全部</Option>
                <Option value="none">普通</Option>
                <Option value="candidate">候选</Option>
                <Option value="confirmed">已确认</Option>
                <Option value="ignored">已忽略</Option>
              </Select>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button icon={<ReloadOutlined />} onClick={onReset}>
                重置
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col>
          <Space size={8}>
            <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
              新建产品
            </Button>
            <Button icon={<SyncOutlined />} loading={syncLoading} onClick={onSyncExternal}>
              同步外部产品
            </Button>
            <Button
              icon={<SyncOutlined spin={proxySyncLoading} />}
              loading={proxySyncLoading}
              onClick={onSyncExternalProxy}
              disabled={syncLoading}
            >
              代理同步产品
            </Button>
            {selectedCount > 0 && (
              <Dropdown
                menu={{
                  items: [
                    {
                      key: 'batch-pin',
                      label: '批量置顶',
                      icon: <PushpinOutlined />,
                      onClick: () => onBatchPin(true),
                    },
                    {
                      key: 'batch-unpin',
                      label: '批量取消置顶',
                      icon: <PushpinFilled />,
                      onClick: () => onBatchPin(false),
                    },
                  ],
                }}
              >
                <Button loading={pinLoading}>
                  批量操作 ({selectedCount}) <MoreOutlined />
                </Button>
              </Dropdown>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default ProductFilters;
